import { LitElement, html, css, ref, createRef } from '@hh/global.js'
import { utils } from '@hh/global.js'

const { debounce } = utils

class InlineFilters extends LitElement {
  static properties = {
    filters: {
      type: Object,
    },
    _formFacets: {
      state: true,
      type: Object,
    },
    _filterData: {
      state: true,
      type: Array,
    },
    gridId: {
      attribute: 'grid-id',
      type: String,
    },
    gridSelector: {
      attribute: 'grid-selector',
      type: String,
    },
    tAll: {
      attribute: 't-all',
      type: String,
    },
  }

  $form = createRef()

  constructor() {
    super()
    this._formFacets = {}
    this._filterData = []
    this.sorting = this.querySelector('#SortBy')

    this.debounceOnFormChange = debounce((e) => {
      this.onFormChange(e)
    }, 500)

    this.classes = {
      loading: 'loading',
    }
  }

  connectedCallback() {
    super.connectedCallback()
    window.addEventListener('popstate', this.onHistoryChange.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('popstate', this.onHistoryChange.bind(this))
  }

  _setFormData(e) {
    const { detail } = e
    this._formFacets = Object.assign({}, detail)
  }

  onFormChange(e) {
    const formData = new FormData(this.$form?.value)
    formData.set('sort_by', this.sorting.value)
    const searchParams = new URLSearchParams(formData).toString()
    this.renderPage(searchParams, e)
  }

  onHistoryChange(event) {
    console.log(event)
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document
      .getElementById(this.gridId)
      .querySelector(this.gridSelector)
      .classList.add(this.classes.loading)

    const url =
      `${window.location.pathname}?` +
      this.getSections()
        .map((section) => `sections[]=${section.section}`)
        .join('&') +
      `&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this._filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this._filterData = [...this._filterData, { html, url }]
        this.renderProductGrid(html)
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this._filterData.find(filterDataUrl).html
    this.renderProductGrid(html)
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById(this.gridId).innerHTML

    document.getElementById(this.gridId).innerHTML = innerHTML
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset
          .id,
      },
    ]
  }

  render() {
    return html`<!-- @ts-ignore no-incompatible-type-binding -->
      <form
        id="filter-form"
        @input=${this.debounceOnFormChange}
        ${ref(this.$form)}
      >
        ${(Object.keys(this._formFacets).length !== 0 &&
          Object.keys(this._formFacets).map((key) => {
            const facet = this._formFacets[key]
            return facet.map((f) => {
              return html` <input type="hidden" name="${key}" value="${f}" /> `
            })
          })) ||
        ''}
        ${Object.keys(this.filters).map((f) => {
          const filter = this.filters[f]
          return html`
            <hh-inline-filter
              @active-facets=${this._setFormData}
              .filter=${filter}
              .tAll=${this.tAll}
            ></hh-inline-filter>
          `
        })}

        <slot name="sorting"></slot>
      </form> `
  }

  static styles = css`
    :host {
      display: block;
      margin-top: 5rem;
    }

    @media screen and (min-width: 990px) {
      :host {
        margin-top: 2rem;
      }
    }

    @media screen and (min-width: 990px) {
      #filter-form {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  `
}

customElements.define('hh-inline-filters', InlineFilters)
